import API from "../axiosConfig";

export const getSubscriptionAudiences = async () => {
  try {
    const response = await API.get("/subscription-audiences");
    return response.data.data || [];
  } catch (error) {
    console.error("Error fetching subscription audiences:", error);
    throw error;
  }
};

export const createSubscriptionAudience = async (audienceData) => {
  try {
    const response = await API.post("/subscription-audiences", audienceData);
    return response.data;
  } catch (error) {
    console.error("Error creating subscription audience:", error);
    throw error;
  }
};

export const updateSubscriptionAudience = async (id, audienceData) => {
  try {
    const response = await API.put(`/subscription-audiences/${id}`, audienceData);
    return response.data;
  } catch (error) {
    console.error("Error updating subscription audience:", error);
    throw error;
  }
};


// New: Get audiences by subscription type
export const getSubscriptionAudiencesByType = async (subscriptionTypeId) => {
  try {
    const response = await API.get(`/subscription-audiences/by-subscription-type/${subscriptionTypeId}`);
    return response.data.data || [];
  } catch (error) {
    console.error("Error fetching subscription audiences by type:", error);
    throw error;
  }
};
